/** Formate une date locale en AAAA-MM-JJ (sans décalage UTC). */
export function isoOf(d: Date): string {
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

/** Date du jour au format AAAA-MM-JJ (fuseau local). */
export function todayIso(): string {
  return isoOf(new Date());
}
